import { render } from "./StoreReferentInformation.vue?vue&type=template&id=f36e6620"
import script from "./StoreReferentInformation.vue?vue&type=script&lang=js"
export * from "./StoreReferentInformation.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./StoreReferentInformation.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_6bb8f80a%2Fpackages%2Finsurer%2Fsrc%2Fcomponents%2Fstores%2FStoreReferentInformation.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__